// @flow
import moment from "moment"

// eslint-disable-next-line
;["ar", "my"].forEach(x => {
  // Disable arabic number to symbol mapping 1: ١, 2: ٢, 3: ٣, 4: ٤, 5: ٥, 6: ٦, 7: ٧, 8: ٨, 9: ٩, 0: ٠
  const localeData = moment.localeData(x)
  localeData.postformat = y => y
  moment.updateLocale(x, localeData)
})
